import { OverviewItem } from '../domain/overviewItem'
import { UnifiedShipmentsSearchHit } from '../types'

// searchlight serves both flags off the indexed document: the response drops the customs
// items and the cargo UN numbers they would otherwise be derived from
export const withSearchFlags = (overviewItem: OverviewItem, hit: UnifiedShipmentsSearchHit): OverviewItem => ({
  ...overviewItem,
  hasCustoms: hit.customs === true,
  hasDangerousGoods: hit.dangerousGoods === true,
})
